import { render, staticRenderFns } from "./rekoninvkr.vue?vue&type=template&id=42fc53a3"
import script from "./rekoninvkr.vue?vue&type=script&lang=js"
export * from "./rekoninvkr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports